import { Component } from '@verndale/core';
import { gsap, Expo, CSSPlugin } from 'gsap';
import { keyCode } from '../helpers';
import BrandsDrawer from './brandsDrawer';

gsap.registerPlugin(CSSPlugin);

class Module extends Component {
  setupDefaults() {
    this.id = this.el.dataset.id;
    this.breakpoint = window.matchMedia('(min-width: 1280px)');
    this.floatingMenu = false;
    this.floatingSearchHeaderInitialized = false;
    this.floatingFindLocationInitialized = false;
    this.fullMenu = false;
    this.lastActiveElement = null;

    this.dom = {
      headerToggle: this.el.querySelector('.header__toggle'),
      headerInner: this.el.querySelector('.header__inner'),
      headerMain: this.el.querySelector('.header__main'),
      utilityNavigationLinks: this.el.querySelector(
        '.utility-navigation__list'
      ),
      primaryNavigation: this.el.querySelector('.primary-navigation'),
      primaryNavigationMenu: this.el.querySelector('.primary-navigation__menu'),
      primaryNavigationLinks: [
        ...this.el.querySelectorAll('.primary-navigation__link')
      ],
      submenus: [...this.el.querySelectorAll('.primary-navigation__submenu')],
      submenuLinks: [
        ...this.el.querySelectorAll(
          '.primary-navigation__submenu [tabindex="-1"]'
        )
      ],
      submenuTriggers: [
        ...this.el.querySelectorAll(
          '.primary-navigation__link[aria-haspopup=true]'
        )
      ],
      submenuCloseButtons: [
        ...this.el.querySelectorAll('.primary-navigation__back')
      ],
      primaryNavigationUtilityLinks: this.el.querySelector(
        '.primary-navigation__bottom-links'
      ),
      brandsDrawer: this.el.querySelector('.brands-drawer'),
      headerFindLocationTrigger: this.el.querySelectorAll(
        '.header__main .header__find-location-link'
      ),
      headerFindLocationFormContainer: this.el.querySelector(
        '.header__main .header__find-location'
      ),
      headerFindLocationForm: this.el.querySelector(
        '.header__main .header__find-location__search-form form'
      ),
      headerSearch: this.el.querySelector('.header__main .header__search'),
      headerSearchForm: this.el.querySelector(
        '.header__main .header__search__form'
      ),
      headerSearchTriggers: [
        ...this.el.querySelectorAll(
          '.header__main .header__search__form__trigger'
        )
      ],
      headerSearchInput: this.el.querySelector(
        '.header__main .header__search__form__input'
      )
    };

    this.floatingHeaderSearchDom = () => ({
      headerSearchTriggers: [
        ...this.el.querySelectorAll(
          '.header__floating .header__search__form__trigger'
        )
      ],
      headerSearchInput: this.el.querySelector(
        '.header__floating .header__search__form__input'
      ),
      headerSearchForm: this.el.querySelector(
        '.header__floating .header__search__form'
      )
    });

    this.floatingHeaderFindLocationDom = () => ({
      headerFindLocationTrigger: this.el.querySelectorAll(
        '.header__floating .header__find-location-link'
      ),
      headerFindLocationFormContainer: this.el.querySelector(
        '.header__floating .header__find-location'
      ),
      headerFindLocationForm: this.el.querySelector(
        '.header__floating .header__find-location__search-form form'
      )
    });

    this.searchRedirect = this.dom.headerSearchForm.dataset.redirect;

    this.cloneMenu();
    if (this.dom.brandsDrawer) {
      this.brandsDrawer = new BrandsDrawer(this.dom.brandsDrawer);
    }
  }

  addListeners() {
    this.dom.headerToggle.addEventListener(
      'click',
      this.handleToggle.bind(this)
    );
    this.dom.submenuTriggers.forEach(trigger =>
      trigger.addEventListener('click', this.handleMobileSubmenuOpen.bind(this))
    );
    this.dom.submenuCloseButtons.forEach(button =>
      button.addEventListener('click', this.handleSubmenuClose.bind(this))
    );
    this.dom.submenuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', this.handleSubmenuOpen.bind(this));
      trigger.parentNode.addEventListener(
        'mouseleave',
        this.handleSubmenuClose.bind(this)
      );
    });

    this.dom.primaryNavigationLinks.forEach(link => {
      link.addEventListener('keydown', this.handleKeydown.bind(this));
    });

    this.dom.submenuLinks.forEach(link => {
      link.addEventListener('keydown', this.handleSubmenuKeydown.bind(this));
      link.addEventListener('click', this.handleToggle.bind(this));
    });
    this.setupHeaderSearchEvents(this.dom);
    this.setupHeaderFindLocationEvents(this.dom);
    window.addEventListener('click', () => {
      this.closeAllSearchForms();
      this.closeAllFindLocationForms();
    });
  }

  cloneMenu() {
    this.dom.floatingMenu = document.createElement('div');
    this.dom.floatingMenu.classList.add('header__floating');
    this.dom.floatingMenu.innerHTML = this.dom.headerMain.innerHTML;
    this.dom.floatingMenu
      .querySelector('.header__toggle')
      .addEventListener('click', this.handleFloatingMenuClick.bind(this));
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll.bind(this));

    if (this.dom.brandsDrawer) {
      this.dom.mobileBrandsDrawer = document.createElement('div');
      this.dom.mobileBrandsDrawer.classList.add('mobile-brands-drawer');
      this.dom.mobileBrandsDrawer.innerHTML = this.dom.brandsDrawer.innerHTML;
      this.dom.primaryNavigationUtilityLinks.prepend(
        this.dom.mobileBrandsDrawer
      );

      this.dom.brandsDrawerToggleMobile = this.dom.primaryNavigationUtilityLinks.querySelector(
        '.brands-drawer__toggle'
      );
      this.dom.brandsDrawerBackButton = this.dom.primaryNavigationUtilityLinks.querySelector(
        '.primary-navigation__back'
      );
      this.dom.brandsDrawerToggleMobile.addEventListener(
        'click',
        this.handleMobileBrandDrawerOpen.bind(this)
      );
      this.dom.brandsDrawerBackButton.addEventListener(
        'click',
        this.handleMobileBrandDrawerClose.bind(this)
      );
    }

    /*this.dom.separator = document.createElement('hr');
    this.dom.separator.classList.add('separator');
    this.dom.mobileUtilityNav = document.createElement('ul');
    this.dom.mobileUtilityNav.classList.add('mobile-utility-navigation');
    this.dom.mobileUtilityNav.innerHTML = this.dom.utilityNavigationLinks.innerHTML;
    this.dom.primaryNavigationMenu.appendChild(this.dom.separator);
    this.dom.primaryNavigationMenu.appendChild(this.dom.mobileUtilityNav);

    if (this.dom.brandsDrawer) {
      this.dom.mobileBrandsDrawer = document.createElement('li');
      this.dom.mobileBrandsDrawer.classList.add('mobile-brands-drawer');
      this.dom.mobileBrandsDrawer.innerHTML = this.dom.brandsDrawer.innerHTML;
      this.dom.mobileUtilityNav.prepend(this.dom.mobileBrandsDrawer);

      this.dom.brandsDrawerToggleMobile = this.dom.mobileUtilityNav.querySelector(
        '.brands-drawer__toggle'
      );
      this.dom.brandsDrawerBackButton = this.dom.mobileUtilityNav.querySelector(
        '.primary-navigation__back'
      );
      this.dom.brandsDrawerToggleMobile.addEventListener(
        'click',
        this.handleMobileBrandDrawerOpen.bind(this)
      );
      this.dom.brandsDrawerBackButton.addEventListener(
        'click',
        this.handleMobileBrandDrawerClose.bind(this)
      );
    }*/
  }

  handleScroll() {
    if (this.breakpoint.matches) {
      if (window.pageYOffset >= this.el.offsetHeight) {
        this.brandsDrawer && this.brandsDrawer.close();
        this.showFloatingMenu();
      }

      if (window.pageYOffset < this.el.offsetHeight) {
        this.disableFloatingMenu();
      }

      if (this.fullMenu && Math.abs(window.pageYOffset - this.scroll) > 150) {
        this.fullMenu = false;
        this.dom.submenus.forEach(submenu => submenu.removeAttribute('style'));
        gsap.to(this.dom.headerInner, {
          y: '-100%',
          ease: gsap.Linear,
          duration: 0.5,
          onComplete: () => {
            this.dom.headerInner.removeAttribute('style');
          }
        });
      }
    }
  }

  handleFloatingMenuClick() {
    this.fullMenu = true;
    this.scroll = window.pageYOffset;
    gsap.to(this.dom.headerInner, {
      y: 0,
      ease: gsap.Linear,
      duration: 0.5,
      onComplete: () => {
        this.dom.headerInner.style.pointerEvents = null;
        this.dom.headerInner.focus();
      }
    });
  }

  showFloatingMenu() {
    if (!this.floatingMenu) {
      this.floatingMenu = true;
      this.fullMenu = false;
      this.el.appendChild(this.dom.floatingMenu);
      gsap.to(this.dom.floatingMenu, {
        y: 0,
        ease: Expo.easeOut,
        duration: 0.3
      });
      this.dom.submenus.forEach(submenu => submenu.removeAttribute('style'));
      this.dom.headerInner.classList.add('header__inner--fixed');
      // Initialized the search header
      if (!this.floatingSearchHeaderInitialized) {
        this.setupHeaderSearchEvents(this.floatingHeaderSearchDom());
        this.floatingSearchHeaderInitialized = true;
      }
      // Sync floating search header
      const mainHeaderSearchInput = this.dom.headerSearchInput;
      if (mainHeaderSearchInput.value) {
        const { headerSearchInput } = this.floatingHeaderSearchDom();
        headerSearchInput.value = mainHeaderSearchInput.value;
        this.openSearchForm(headerSearchInput);
      }
      //Close All find location
      this.closeAllFindLocationForms(false);
      //Initialize the find location
      if (!this.floatingFindLocationInitialized) {
        this.setupHeaderFindLocationEvents(
          this.floatingHeaderFindLocationDom()
        );
        this.floatingFindLocationInitialized = true;
      }
    }
  }

  hideFloatingMenu() {
    if (this.floatingMenu) {
      this.floatingMenu = false;
      const { headerSearchInput } = this.floatingHeaderSearchDom();
      this.closeSearchForm(
        document.querySelector('.header__floating .header__search__form__input')
      );
      if (headerSearchInput.value) {
        this.dom.headerSearchInput.value = headerSearchInput.value;
        this.openSearchForm(this.dom.headerSearchInput);
      } else {
        this.closeSearchForm(this.dom.headerSearchInput);
      }
      gsap.to(this.dom.floatingMenu, {
        y: '-100%',
        duration: 0.3,
        onComplete: () => {
          this.dom.floatingMenu.remove();
        }
      });
    }
  }

  disableFloatingMenu() {
    if (this.dom.headerInner.classList.contains('header__inner--fixed')) {
      this.dom.headerInner.classList.remove('header__inner--fixed');
      this.dom.headerInner.removeAttribute('style');
    }
    this.fullMenu = false;
    this.hideFloatingMenu();
  }

  handleToggle() {
    if (this.dom.headerToggle.classList.contains('header__toggle--open')) {
      document.body.classList.remove('body--mobile-menu');
      window.scrollTo(0, this.scroll);

      this.dom.headerToggle.classList.remove('header__toggle--open');
      gsap.to(this.dom.primaryNavigation, {
        x: '100%',
        ease: gsap.Linear,
        duration: 0.4
      });
    } else {
      this.scroll = window.scrollY;
      document.body.style.top = `-${this.scroll}px`;
      document.body.classList.add('body--mobile-menu');

      this.dom.headerToggle.classList.add('header__toggle--open');
      gsap.to(this.dom.primaryNavigation, {
        x: 0,
        ease: gsap.Linear,
        duration: 0.4,
        onComplete: () => {
          this.dom.primaryNavigation.style.maxHeight = `${
            window.innerHeight - 60
          }px`;
        }
      });
    }
  }

  handleMobileSubmenuOpen(e) {
    if (!this.breakpoint.matches) {
      e.preventDefault();
      const submenu = e.currentTarget.nextElementSibling;
      gsap.to(submenu, { x: 0, ease: gsap.Linear, duration: 0.4 });
    }
  }

  handleMobileBrandDrawerOpen(e) {
    if (!this.breakpoint.matches) {
      e.preventDefault();
      const submenu = e.currentTarget.nextElementSibling;
      gsap.to(submenu, { x: 0, ease: gsap.Linear, duration: 0.4 });
    }
  }

  handleMobileBrandDrawerClose(e) {
    if (!this.breakpoint.matches) {
      const submenu = e.currentTarget.parentNode.parentNode;
      gsap.to(submenu, { x: '100%', ease: gsap.Linear, duration: 0.4 });
    }
  }

  handleSubmenuOpen(e) {
    if (this.breakpoint.matches) {
      const submenu = e.currentTarget.nextElementSibling;
      e.currentTarget.classList.add('primary-navigation__link--open');
      gsap.to(submenu, {
        opacity: 1,
        visibility: 'visible',
        ease: Expo.easeInOut,
        duration: 0.2
      });
    }
  }

  handleSubmenuClose(e) {
    if (e.type === 'mouseleave' && !this.breakpoint.matches) return;

    const link = e.currentTarget.querySelector(
      '.primary-navigation__link--secondary'
    );
    let submenu = e.currentTarget.querySelector('.primary-navigation__submenu');

    if (!this.breakpoint.matches) {
      submenu = e.currentTarget.parentNode.parentNode;
      gsap.to(submenu, { x: '100%', ease: gsap.Linear, duration: 0.4 });
    } else {
      link.classList.remove('primary-navigation__link--open');
      gsap.to(submenu, {
        opacity: 0,
        visibility: 'hidden',
        ease: Expo.easeInOut,
        duration: 0.2
      });
    }
  }

  handleKeydown(e) {
    const { parentNode } = e.currentTarget;
    const previousSibling = parentNode.previousElementSibling;
    const nextSibling = parentNode.nextElementSibling;
    const firstSibling = parentNode.parentNode.firstElementChild;
    const lastSibling = parentNode.parentNode.lastElementChild;
    const submenu = e.currentTarget.nextElementSibling;

    let submenuFocusableChildren, newActiveElement;

    switch (e.keyCode) {
      case keyCode.HOME:
        this.focusPrimaryNavigationLink(e, firstSibling);
        break;
      case keyCode.END:
        this.focusPrimaryNavigationLink(e, lastSibling);
        break;
      case keyCode.RIGHT:
        newActiveElement = nextSibling || firstSibling;
        this.focusPrimaryNavigationLink(e, newActiveElement);
        break;
      case keyCode.LEFT:
        newActiveElement = previousSibling || lastSibling;
        this.focusPrimaryNavigationLink(e, newActiveElement);
        break;
      case keyCode.DOWN:
        if (e.currentTarget.getAttribute('aria-haspopup') && submenu) {
          e.preventDefault();
          gsap.to(submenu, {
            opacity: 1,
            visibility: 'visible',
            ease: Expo.easeInOut,
            duration: 0.2,
            onComplete: () => {
              submenuFocusableChildren = this.getFocusableChildren(submenu);
              submenuFocusableChildren[0].focus();
            }
          });
        }
        break;
      case keyCode.UP:
        if (e.currentTarget.getAttribute('aria-haspopup') && submenu) {
          gsap.to(submenu, {
            opacity: 1,
            visibility: 'visible',
            ease: Expo.easeInOut,
            duration: 0.2,
            onComplete: () => {
              submenuFocusableChildren = this.getFocusableChildren(submenu);
              submenuFocusableChildren[
                submenuFocusableChildren.length - 1
              ].focus();
            }
          });
        }
        break;
    }
  }

  focusPrimaryNavigationLink(e, link) {
    e.preventDefault();
    link.firstElementChild.focus();
    link.firstElementChild.setAttribute('tabindex', 0);
    e.currentTarget.setAttribute('tabindex', -1);
  }

  handleSubmenuKeydown(e) {
    const { parentNode } = e.currentTarget;
    const submenu = e.currentTarget.closest('.primary-navigation__submenu');
    const primaryNavLink = submenu.previousElementSibling;
    const submenuFocusableChildren = this.getFocusableChildren(submenu);

    switch (e.keyCode) {
      case keyCode.TAB:
        gsap.to(submenu, {
          opacity: 0,
          visibility: 'hidden',
          ease: Expo.easeInOut,
          duration: 0.2
        });
        break;
      case keyCode.ESC:
        e.preventDefault();
        gsap.to(submenu, {
          opacity: 0,
          visibility: 'hidden',
          ease: Expo.easeInOut,
          duration: 0.2
        });
        primaryNavLink.focus();
        break;
      case keyCode.HOME:
        e.preventDefault();
        submenuFocusableChildren[0].focus();
        break;
      case keyCode.END:
        e.preventDefault();
        submenuFocusableChildren[submenuFocusableChildren.length - 1].focus();
        break;
      case keyCode.RIGHT:
      case keyCode.DOWN:
        e.preventDefault();

        if (
          e.currentTarget.classList.contains('primary-navigation__submenu-link')
        ) {
          if (parentNode.nextElementSibling) {
            parentNode.nextElementSibling.firstElementChild.focus();
          } else {
            submenuFocusableChildren[0].focus();
          }
        } else {
          if (e.currentTarget.nextElementSibling) {
            e.currentTarget.nextElementSibling.focus();
          } else {
            const nextElement = parentNode.nextElementSibling;

            if (
              nextElement.classList.contains('primary-navigation__submenu-list')
            ) {
              nextElement.firstElementChild.firstElementChild.focus();
            } else {
              submenuFocusableChildren[0].focus();
            }
          }
        }

        break;
      case keyCode.LEFT:
      case keyCode.UP:
        e.preventDefault();

        if (
          e.currentTarget.classList.contains('primary-navigation__submenu-link')
        ) {
          if (parentNode.previousElementSibling) {
            parentNode.previousElementSibling.firstElementChild.focus();
          } else {
            const previousElement =
              parentNode.parentNode.previousElementSibling;
            if (
              previousElement.classList.contains('navigation-promo__container')
            ) {
              previousElement.lastElementChild.focus();
            } else {
              submenuFocusableChildren[
                submenuFocusableChildren.length - 1
              ].focus();
            }
          }
        } else {
          if (e.currentTarget.previousElementSibling) {
            e.currentTarget.previousElementSibling.focus();
          } else {
            submenuFocusableChildren[
              submenuFocusableChildren.length - 1
            ].focus();
          }
        }

        break;
    }
  }

  getFocusableChildren(el) {
    if (!el) return;

    return [...el.querySelectorAll('[tabindex="-1"]')]
      .filter(el => !el.hasAttribute('disabled'))
      .filter(el => window.getComputedStyle(el).display !== 'none')
      .filter(el => window.getComputedStyle(el).visibility !== 'hidden');
  }

  setupHeaderSearchEvents(elements, eventOperation = 'addEventListener') {
    elements.headerSearchTriggers.forEach(searchTrigger => {
      searchTrigger[eventOperation](
        'click',
        this.handleSearchTriggerClick.bind(this)
      );
    });
    elements.headerSearchInput[eventOperation](
      'keydown',
      this.handleSearchInputKeydown.bind(this)
    );
    elements.headerSearchForm[eventOperation](
      'submit',
      this.handleSearchFormSubmit.bind(this)
    );
    elements.headerSearchForm[eventOperation]('click', e =>
      e.stopPropagation()
    );
  }

  openSearchForm(target) {
    this.closeAllFindLocationForms(false);
    this.lastActiveElement = document.activeElement;
    const currentHeaderSearch = target.closest('.header__search');
    const headerSearchInput = currentHeaderSearch.querySelector(
      '.header__search__form__input'
    );
    currentHeaderSearch.classList.add('active');
    headerSearchInput.focus();
    headerSearchInput.setAttribute('aria-hidden', 'false');
  }

  closeSearchForm(target) {
    this.closeAllFindLocationForms(false);
    const currentHeaderSearch = target.closest('.header__search');
    const headerSearchInput = currentHeaderSearch.querySelector(
      '.header__search__form__input'
    );
    currentHeaderSearch.classList.remove('active');
    setTimeout(() => {
      headerSearchInput.value = '';
    }, 300);
    if (this.lastActiveElement) this.lastActiveElement.focus();
    headerSearchInput.setAttribute('aria-hidden', 'true');
    this.lastActiveElement = null;
  }

  closeAllSearchForms() {
    // Remove Active class of all search forms
    [...document.querySelectorAll('.header__search')].forEach(searchForm =>
      searchForm.classList.remove('active')
    );
    // Clear and add aria-hidden attribute to all search form inputs
    setTimeout(() => {
      [...document.querySelectorAll('.header__search__form__input')].forEach(
        searchFormInput => {
          searchFormInput.value = '';
          searchFormInput.setAttribute('aria-hidden', 'true');
        }
      );
    }, 300);
    // Set last active element
    if (this.lastActiveElement) this.lastActiveElement.focus();
    this.lastActiveElement = null;
  }

  handleSearchTriggerClick(event) {
    event.stopPropagation();
    const { currentTarget } = event;
    if (currentTarget.closest('.header__search').classList.contains('active')) {
      return this.closeSearchForm(currentTarget);
    }
    this.openSearchForm(currentTarget);
  }

  handleSearchInputKeydown(event) {
    if (event && event.keyCode && event.keyCode === 27) {
      this.closeSearchForm(event.currentTarget);
    }
  }

  handleSearchFormSubmit(event) {
    event.stopPropagation();
    event.preventDefault();
    const { currentTarget } = event;
    const currentHeaderSearch = currentTarget.closest('.header__search');
    const headerSearchInput = currentHeaderSearch.querySelector(
      '.header__search__form__input'
    );
    const searchQuery = headerSearchInput.value;
    if (currentTarget.closest('.header__search').classList.contains('active')) {
      if (searchQuery) {
        window.location.assign(
          `${this.searchRedirect}?searchQuery=${searchQuery}&pageNumber=1`
        );
      }
    } else {
      this.openSearchForm(currentTarget);
    }
  }

  setupHeaderFindLocationEvents(elements, eventOperation = 'addEventListener') {
    elements.headerFindLocationTrigger.forEach(findLocationTrigger => {
      findLocationTrigger[eventOperation](
        'click',
        this.handleFindLocationTriggerClick.bind(this)
      );
    });
    [...elements.headerFindLocationForm.querySelectorAll('input')].forEach(
      findLocationInput => {
        findLocationInput.addEventListener(
          'keydown',
          this.handleFindLocationInputKey.bind(this)
        );
      }
    );
    elements.headerFindLocationForm.addEventListener(
      'submit',
      this.handleFindLocationFormSubmit.bind(this)
    );
    elements.headerFindLocationFormContainer.addEventListener('click', e =>
      e.stopPropagation()
    );
  }

  openFindLocationForm(form, closeAllSearchForms = true) {
    if (closeAllSearchForms) this.closeAllSearchForms();
    this.lastActiveElement = document.activeElement;
    form.classList.add('active');
    gsap.to(form, {
      opacity: 1,
      display: 'block',
      ease: Expo.easeInOut,
      duration: 0.2
    });
    setTimeout(() => {
      const firstInput = form.querySelector('input');
      firstInput.focus();
    }, 300);
    form.setAttribute('aria-hidden', 'false');
  }

  closeFindLocationForm(form, closeAllSearchForms = true) {
    if (closeAllSearchForms) this.closeAllSearchForms();
    form.classList.remove('active');
    gsap.to(form, {
      opacity: 0,
      display: 'none',
      ease: Expo.easeInOut,
      duration: 0.2
    });
    form.setAttribute('aria-hidden', 'true');
    if (this.lastActiveElement) this.lastActiveElement.focus();
    this.lastActiveElement = null;
  }

  closeAllFindLocationForms(closeAllSearchForms = true) {
    [
      ...document.querySelectorAll('.header__find-location__search-form')
    ].forEach(findLocationForm =>
      this.closeFindLocationForm(findLocationForm, closeAllSearchForms)
    );
  }

  handleFindLocationInputKey(event) {
    if (event.keyCode === 27) {
      const { currentTarget } = event;
      const currentForm = currentTarget.closest(
        '.header__find-location__search-form'
      );
      this.closeFindLocationForm(currentForm);
    }
  }

  handleFindLocationTriggerClick(event) {
    const { currentTarget } = event;
    const currentForm = currentTarget.nextElementSibling;
    if (currentForm.classList.contains('active')) {
      return this.closeFindLocationForm(currentForm);
    }
    this.openFindLocationForm(currentForm);
  }

  handleFindLocationFormSubmit(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const redirectUrl = currentTarget.dataset.redirect;
    let queryParams = '';
    [...currentTarget.querySelectorAll('input')]
      .filter(input => input.value.trim())
      .forEach((input, index) => {
        queryParams = queryParams.concat(index === 0 ? '?' : '&');
        queryParams = queryParams.concat(
          `${input.getAttribute('name')}=${encodeURIComponent(input.value)}`
        );
      });
    window.location.assign(`${redirectUrl}${queryParams}`);
  }
}

export default Module;
